module.exports = __webpack_public_path__ + "static/media/gear.14845592.svg";